import React from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from '@tradera/tradera-ui/icons/arrow-down.svg?jsx';

const AccordionItem = ({
    render,
    title,
    label,
    isOpen,
    onChange,
    collapsable = true,
    hideTitle = false,
    handleChange,
    css = ''
}) => {
    return (
        <div className={`accordion-item ${css}`}>
            {hideTitle ? (
                <div className="item-body">
                    <div className="list-group-item">{render()}</div>
                </div>
            ) : (
                <div>
                    <div
                        className={`list-group-item ${
                            collapsable ? 'list-group-item-action' : ''
                        }`}
                        onClick={
                            collapsable
                                ? () => {
                                      handleChange(title);
                                      if (onChange) {
                                          onChange(!isOpen); // send in the new value
                                      }
                                  }
                                : null
                        }>
                        <div className="d-flex justify-content-between align-items-center">
                            <span className={isOpen ? 'font-weight-bold' : ''}>
                                {title}
                            </span>
                            <div>
                                {label ? (
                                    <span className="mr-3">{label}</span>
                                ) : null}
                                {collapsable ? (
                                    <span
                                        className={`arrow ${
                                            isOpen ? 'open' : ''
                                        }`}>
                                        <ArrowIcon className="icon icon-xs icon-dark" />
                                    </span>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className={`item-body ${isOpen ? '' : 'collapsed'}`}>
                        <div className="list-group-item">{render()}</div>
                    </div>
                </div>
            )}
        </div>
    );
};

AccordionItem.propTypes = {
    render: PropTypes.func.isRequired,
    css: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.node,
    isOpen: PropTypes.bool,
    collapsable: PropTypes.bool,
    hideTitle: PropTypes.bool,
    handleChange: PropTypes.func, // this method is injected from the <Accordion></Accordion> component
    onChange: PropTypes.func
};

export default AccordionItem;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/accordion/accordion-item.jsx